var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14703_17079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5558 5.60742H6.12529C4.56917 5.60742 3.33549 6.85512 3.33549 8.41124L3.32147 25.2342C3.32147 26.7903 4.56917 28.038 6.12529 28.038H28.5558C30.112 28.038 31.3597 26.7903 31.3597 25.2342V8.41124C31.3597 6.85512 30.112 5.60742 28.5558 5.60742ZM28.5558 25.2342H6.12529V16.8227H28.5558V25.2342ZM28.5558 11.2151H6.12529V8.41124H28.5558V11.2151Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14703_17079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6458,
    height: 33.6458,
    fill: "white",
    transform: "translate(0.517639)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardMobile);
export default __webpack_public_path__ + "static/media/credit-card-mobile.1a055070.svg";
export { ForwardRef as ReactComponent };